import script from "./lamplist.vue?vue&type=script&setup=true&lang=js"
export * from "./lamplist.vue?vue&type=script&setup=true&lang=js"

import "./lamplist.vue?vue&type=style&index=0&id=5f3a6679&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3a6679"]])

export default __exports__